import { FunctionComponent, useState, useEffect } from 'react';
import { Dropdown } from '@fluentui/react';
import { IDynamicEditorComponentProps } from './DynamicEditorComponent';
import { Lookup } from '../../../Entities/ContentConfiguration/Lookup/Lookup';
import { DropdownOptionEx } from '../../../Utilities/DropdownOptionEx';
import { ContentConfigurationService } from '../../../Services/ContentConfigurationService';
import { LookupType } from '../../../Entities/ContentConfiguration/Lookup/LookupType';
import { CustomPropertyType } from '../../../api/generated/data-contracts';
 
interface IProps extends IDynamicEditorComponentProps { 
    Item: string;
    Update: (value: string) => void;
    Key?: string;
	CustomPropertyType?: CustomPropertyType;
}

const LookupSelector: FunctionComponent<IProps> = props => {
    const [lookups, setLookups] = useState<Array<Lookup>>();

    useEffect(() => {
		let mounted = true;
        const fetchLookups = async () => {
			let lookups = await ContentConfigurationService.GetLookups();
			if (props.Parent?.Type !== CustomPropertyType.AutoNumber) {
				lookups = lookups.filter(lookup => lookup.LookupType !== LookupType.AutoNumber);
			} else {
				lookups = lookups.filter(lookup => lookup.LookupType === LookupType.AutoNumber);
			}
			if (mounted)
				setLookups(lookups);
        };
		fetchLookups();
		return () => {
			mounted = false
		};
    }, [props.Parent?.Type])

    const onChange = (item: string): void => {
		props.Update(item);
    };

	return  (
		<>
			{ lookups && 
				<Dropdown
					onChange={ (ev, option, idx) => onChange(option.key as string)}
					options={ DropdownOptionEx.toDropdownOptionsAddEmptyEntry(lookups, _ => _.id, _ => _.Name) }
					defaultSelectedKey={ props.Item }
					disabled={props.ReadOnly || !lookups}
				/>
			}
		</>
	)
}

export default LookupSelector;